import React from 'react';
import { connect } from 'dva';
import { getMapStateToProps } from '@/utils/utils';
import { Menu, Button, Icon, Avatar, message } from 'antd';
import HeaderDropdown from '../HeaderDropdown';
import styles from './index.less';
import classNames from 'classnames';
import { router } from 'umi';
import { customisedMediaUrl } from '@/utils/imageTool';

interface HeaderAvatarProps {
  modelKey: any;
}

const HeaderAvatar: React.FC<HeaderAvatarProps> = (props: any) => {
  const {
    meta: {
      isMobile,
      currentUserDetails: { avatar },
    },
    user: { currentUser },
    dispatch,
    helper: { tx },
    modelKey,
  } = props;

  const isLogin = currentUser && currentUser.id ? true : false;

  const isWeb = isMobile ? false : true;

  const loginedClass = classNames(styles.removeBorder, styles.loginedBtns);

  const unLoginClass = classNames(styles.removeBorder, styles.loginBtns);

  const onClickUserProfile = () => {
    router.push('/od/dashboard');
  };

  const toggleSignOut = () => {
    if (isLogin) {
      dispatch({
        type: 'user/clearCurrentUserToken',
      });
      dispatch({
        type: 'od/clearEditingBusiness',
      });

      message.success(tx('Login.already_logged_out'));
      window.location.replace('/user/login');
    }
  };

  const loginMenuDropdown = (
    <Menu>
      <Menu.Item key="email" className={styles.menuItem} onClick={onClickUserProfile}>
        {currentUser.email}
      </Menu.Item>
      <Menu.Item key="signOut" className={styles.menuItem} onClick={toggleSignOut}>
        {tx('Login.sign_out')}
      </Menu.Item>
    </Menu>
  );

  if (isLogin) {
    return (
      <HeaderDropdown overlay={loginMenuDropdown} placement="bottomRight">
        <Button className={loginedClass}>
          <Avatar
            src={avatar && customisedMediaUrl(avatar.url, 96, 96, 50)}
            icon={'user'}
            style={{ backgroundColor: '@primary-color' }}
          />
          <Icon type="down" />
        </Button>
      </HeaderDropdown>
    );
  }

  return (
    <Button className={unLoginClass} onClick={() => router.push('/user/login')}>
      <Avatar size={32} icon="user" />
      {isWeb && tx('Login.login')}
    </Button>
  );
};

export default connect(getMapStateToProps(['meta', 'user']))(HeaderAvatar);
